
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWind12 as ObiWind12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-12.js';
 
 
 

 
 export const ObiWind12 = createComponent({
   react: React,
   tagName: 'obi-wind-12',
   elementClass: ObiWind12Element,
   events: {
     
   }
  });
 
 